"use client";
import { IconColumns } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";

type ColumnsData = {
  id?: number;
  text?: string;
  isShow?: boolean;
  value?: string;
};

type Props = {
  columnsData: ColumnsData[];
  setHeadings?: (value: string | undefined, checked: boolean) => void;
};

export default function ColumnsFilter({ columnsData, setHeadings }: Props) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        className="border-[0.5px] border-gray-300 bg-white rounded-full p-2 cursor-pointer text-sm text-[#212121]"
      >
        <IconColumns strokeWidth={1.5} size={22} />
      </div>
      {open && (
        <div className="absolute mt-2 right-0 bg-white border border-gray-200 shadow-md rounded-md w-52 z-30  max-h-[200px] scrollbar-clean overflow-hidden overflow-y-auto">
          {columnsData.map((h, i) => (
            <label
              className="space-x-2 flex items-center cursor-pointer border-b border-[#d2d2d2] px-3 py-2.5 hover:bg-[#FBD037]/10 last:border-none"
              key={i}
            >
              <label className="flex items-center cursor-pointer relative">
                <input
                  type="checkbox"
                  checked={!!h.isShow}
                  className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-[#FBD037] checked:border-[#FBD037]"
                  onChange={(e) => {
                    setHeadings && setHeadings(h.value, e.target.checked);
                  }}
                />
                <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3.5 w-3.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth={1}
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </label>
              <span className="text-sm">{h.text}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
